import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    subscribeToNewsletter,
    updateNewsletterError,
} from '@client/redux/modules/newsletter/actions';
import { getNewsletterError } from '@client/redux/modules/newsletter/selectors';
import { track } from '@client/helpers/tracking';
import { SubscriptionTarget } from './types';
import { useSubscriptionFlowProps } from './';

export const useSubscriptionFlow = (
    subscriptionTarget: SubscriptionTarget,
): useSubscriptionFlowProps => {
    const dispatch = useDispatch();

    const error = useSelector(getNewsletterError);

    const [rejected, setRejected] = useState(false);
    const [accepted, setAccepted] = useState(false);

    useEffect(() => {
        dispatch(updateNewsletterError);
    }, [dispatch]);

    const reject = useCallback(() => {
        track('secondary_subscription_no_click');
        setRejected(true);
    }, []);

    const confirmEmail = useCallback(
        (emailProvider: string) => () => {
            window.open(`http://www.${emailProvider}`, '_blank');
            track('secondary_subscription_inbox_click');
        },
        [],
    );

    const trackSubscriptionSuccess = useCallback(() => {
        const suffix = rejected ? '2' : '1';
        const errorSuffix = 'error';
        track(`secondary_subscription_yes_${error ? errorSuffix : suffix}_click`);
    }, [error, rejected]);

    const subscribe = useCallback(() => {
        trackSubscriptionSuccess();
        setAccepted(true);
        dispatch(subscribeToNewsletter(subscriptionTarget));
    }, [trackSubscriptionSuccess, dispatch, subscriptionTarget]);

    return {
        rejected,
        accepted,
        error,
        subscribe,
        reject,
        confirmEmail,
    };
};
